import Main from './Main'
import CardDone from './CardDone'
import Billet from './Billet'
import TransferDone from './TransferDone'
import CheckoutYapayDone from './CheckoutYapayDone'
import CheckoutYapay from './CheckoutYapay'
import PaymentYapaySignin from './PaymentYapaySignin'
import PaymentYapayCallback from './PaymentYapayCallback'

export default [
  { path: '/payment/invoice/:id', name: 'payment', component: Main, props: true, meta: { layout: 'subscribe' } },
  { path: '/payment/invoice/:id/yapay/signin/:subdomain', name: 'paymentYapaySignin', component: PaymentYapaySignin, meta: { layout: 'subscribe' } },
  { path: '/payment/yapay/auth/callback/:token', name: 'paymentYapayCallback', component: PaymentYapayCallback, props: true, meta: { layout: 'subscribe' } },
  { path: '/payment/invoice/:id/balance/confirm/:token', name: 'paymentBalanceConfirm', component: CheckoutYapay, props: true, meta: { layout: 'subscribe' } },
  { path: '/payment/invoice/:id/balance/confirm', name: 'paymentMainByBalance', component: Main, props: true, meta: { layout: 'subscribe' } },
  { path: '/payment/invoice/:id/card/success', name: 'paymentCardSuccess', component: CardDone, props: true, meta: { layout: 'subscribe' } },
  { path: '/payment/invoice/:id/billet/success', name: 'paymentBilletSuccess', component: Billet, props: true, meta: { layout: 'subscribe' } },
  { path: '/payment/invoice/:id/transfer/success', name: 'paymentTransferSuccess', component: TransferDone, props: true, meta: { layout: 'subscribe' } },
  { path: '/payment/invoice/:id/balance/success', name: 'paymentBalanceSuccess', component: CheckoutYapayDone, props: true, meta: { layout: 'subscribe' } }
]




// WEBPACK FOOTER //
// ./src/app/pages/payments/routes.js